// skills/cooking/cookingData.js
// Cooking food and configuration

export const FOOD = {
    SAND_SMELT: {
        id: 'sand_smelt_cook',
        name: 'Sand Smelt',
        level: 1,
        xp: 30,
        baseTime: 2000,
        inputItem: 'raw_sand_smelt',
        inputQuantity: 1,
        drops: [
            { itemId: 'cooked_sand_smelt', weight: 1, quantity: 1 }
        ],
        color: '#ff6b9d'
    },
    SILVER_SPRAT: {
        id: 'silver_sprat_cook',
        name: 'Silver Sprat',
        level: 5,
        xp: 40,
        baseTime: 2200,
        inputItem: 'raw_silver_sprat',
        inputQuantity: 1,
        drops: [
            { itemId: 'cooked_silver_sprat', weight: 1, quantity: 1 }
        ],
        color: '#c0c0c0'
    },
    BLUEBACK: {
        id: 'blueback_cook',
        name: 'Blueback',
        level: 10,
        xp: 50,
        baseTime: 2400,
        inputItem: 'raw_blueback',
        inputQuantity: 1,
        drops: [
            { itemId: 'cooked_blueback', weight: 1, quantity: 1 }
        ],
        color: '#4682b4'
    },
    RIVER_CHAR: {
        id: 'river_char_cook',
        name: 'River Char',
        level: 20,
        xp: 70,
        baseTime: 2800,
        inputItem: 'raw_river_char',
        inputQuantity: 1,
        drops: [
            { itemId: 'cooked_river_char', weight: 1, quantity: 1 }
        ],
        color: '#20b2aa'
    },
    CRIMSON_CHAR: {
        id: 'crimson_char_cook',
        name: 'Crimson Char',
        level: 30,
        xp: 90,
        baseTime: 3200,
        inputItem: 'raw_crimson_char',
        inputQuantity: 1,
        drops: [
            { itemId: 'cooked_crimson_char', weight: 1, quantity: 1 }
        ],
        color: '#fa8072'
    },
    SKIPJACK: {
        id: 'skipjack_cook',
        name: 'Skipjack',
        level: 40,
        xp: 100,
        baseTime: 3600,
        inputItem: 'raw_skipjack',
        inputQuantity: 1,
        drops: [
            { itemId: 'cooked_skipjack', weight: 1, quantity: 1 }
        ],
        color: '#483d8b'
    },
    SPINY_LOBSTER: {
        id: 'spiny_lobster_cook',
        name: 'Spiny Lobster',
        level: 50,
        xp: 120,
        baseTime: 4000,
        inputItem: 'raw_spiny_lobster',
        inputQuantity: 1,
        drops: [
            { itemId: 'cooked_spiny_lobster', weight: 1, quantity: 1 }
        ],
        color: '#dc143c'
    },
    BROADBILL: {
        id: 'broadbill_cook',
        name: 'Broadbill',
        level: 60,
        xp: 140,
        baseTime: 4500,
        inputItem: 'raw_broadbill',
        inputQuantity: 1,
        drops: [
            { itemId: 'cooked_broadbill', weight: 1, quantity: 1 }
        ],
        color: '#708090'
    },
    MAKO: {
        id: 'mako_cook',
        name: 'Mako',
        level: 80,
        xp: 210,
        baseTime: 5000,
        inputItem: 'raw_mako',
        inputQuantity: 1,
        drops: [
            { itemId: 'cooked_mako', weight: 1, quantity: 1 }
        ],
        color: '#2f4f4f'
    }
};

// Empowered recipes - combine cooked fish + matching tier crop for enhanced food
// Uses inputs array (multiple ingredients) and output object (different from FOOD pattern)
export const EMPOWERED_RECIPES = {
    EMPOWERED_SAND_SMELT: {
        id: 'empowered_sand_smelt_cook',
        name: 'Empowered Sand Smelt',
        level: 1,
        xp: 45,
        baseTime: 3000,
        inputs: [
            { itemId: 'cooked_sand_smelt', quantity: 1 },
            { itemId: 'potato', quantity: 1 }
        ],
        output: { itemId: 'empowered_sand_smelt', quantity: 1 },
        color: '#ffb8c5'
    },
    EMPOWERED_SILVER_SPRAT: {
        id: 'empowered_silver_sprat_cook',
        name: 'Empowered Silver Sprat',
        level: 5,
        xp: 60,
        baseTime: 3200,
        inputs: [
            { itemId: 'cooked_silver_sprat', quantity: 1 },
            { itemId: 'onion', quantity: 1 }
        ],
        output: { itemId: 'empowered_silver_sprat', quantity: 1 },
        color: '#e8e8b0'
    },
    EMPOWERED_BLUEBACK: {
        id: 'empowered_blueback_cook',
        name: 'Empowered Blueback',
        level: 10,
        xp: 75,
        baseTime: 3400,
        inputs: [
            { itemId: 'cooked_blueback', quantity: 1 },
            { itemId: 'cabbage', quantity: 1 }
        ],
        output: { itemId: 'empowered_blueback', quantity: 1 },
        color: '#7ab8e8'
    },
    EMPOWERED_RIVER_CHAR: {
        id: 'empowered_river_char_cook',
        name: 'Empowered River Char',
        level: 20,
        xp: 105,
        baseTime: 3800,
        inputs: [
            { itemId: 'cooked_river_char', quantity: 1 },
            { itemId: 'tomato', quantity: 1 }
        ],
        output: { itemId: 'empowered_river_char', quantity: 1 },
        color: '#60d8d0'
    },
    EMPOWERED_CRIMSON_CHAR: {
        id: 'empowered_crimson_char_cook',
        name: 'Empowered Crimson Char',
        level: 30,
        xp: 135,
        baseTime: 4200,
        inputs: [
            { itemId: 'cooked_crimson_char', quantity: 1 },
            { itemId: 'corn', quantity: 1 }
        ],
        output: { itemId: 'empowered_crimson_char', quantity: 1 },
        color: '#ffb890'
    },
    EMPOWERED_SKIPJACK: {
        id: 'empowered_skipjack_cook',
        name: 'Empowered Skipjack',
        level: 40,
        xp: 150,
        baseTime: 4600,
        inputs: [
            { itemId: 'cooked_skipjack', quantity: 1 },
            { itemId: 'strawberry', quantity: 1 }
        ],
        output: { itemId: 'empowered_skipjack', quantity: 1 },
        color: '#8a7ae8'
    },
    // Tier 7-9: These produce food with HoT effect
    EMPOWERED_SPINY_LOBSTER: {
        id: 'empowered_spiny_lobster_cook',
        name: 'Empowered Spiny Lobster',
        level: 50,
        xp: 180,
        baseTime: 5000,
        inputs: [
            { itemId: 'cooked_spiny_lobster', quantity: 1 },
            { itemId: 'watermelon', quantity: 1 }
        ],
        output: { itemId: 'empowered_spiny_lobster', quantity: 1 },
        hasHot: true,  // Indicator for UI
        color: '#ff6060'
    },
    EMPOWERED_BROADBILL: {
        id: 'empowered_broadbill_cook',
        name: 'Empowered Broadbill',
        level: 60,
        xp: 210,
        baseTime: 5500,
        inputs: [
            { itemId: 'cooked_broadbill', quantity: 1 },
            { itemId: 'starbloom', quantity: 1 }
        ],
        output: { itemId: 'empowered_broadbill', quantity: 1 },
        hasHot: true,
        color: '#a0b0c0'
    },
    EMPOWERED_MAKO: {
        id: 'empowered_mako_cook',
        name: 'Empowered Mako',
        level: 80,
        xp: 315,
        baseTime: 6000,
        inputs: [
            { itemId: 'cooked_mako', quantity: 1 },
            { itemId: 'kings_fruit', quantity: 1 }
        ],
        output: { itemId: 'empowered_mako', quantity: 1 },
        hasHot: true,
        color: '#6f8f8f'
    }
};

export const TOOLS = {
    BASIC: {
        id: 'basic_range',
        name: 'Basic Range',
        level: 1,
        speedMultiplier: 1.0,
        price: 0
    },
    BLACKIRON: {
        id: 'blackiron_range',
        name: 'Blackiron Range',
        level: 15,
        speedMultiplier: 1.2,
        price: 1000
    },
    PALE_SHARD: {
        id: 'pale_shard_range',
        name: 'Pale Shard Range',
        level: 30,
        speedMultiplier: 1.4,
        price: 5000
    },
    SKYIRON: {
        id: 'skyiron_range',
        name: 'Skyiron Range',
        level: 45,
        speedMultiplier: 1.6,
        price: 25000
    },
    VERDANT: {
        id: 'verdant_range',
        name: 'Verdant Range',
        level: 60,
        speedMultiplier: 1.8,
        price: 100000
    },
    VOIDSTEEL: {
        id: 'voidsteel_range',
        name: 'Voidsteel Range',
        level: 75,
        speedMultiplier: 2.0,
        price: 250000
    }
};

export default {
    FOOD,
    EMPOWERED_RECIPES,
    TOOLS
};
